module.exports = __webpack_public_path__ + "img/ba.3f0d180e.svg";